import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Order } from '@cemex-core/cmx-api';
import { Store } from '@ngrx/store';
import { SHIPPING_CONDITION_CODE } from '@ordersnproducts/modules/shared/constants/shipping-conditions-codes';
import { ConfigurableFormComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/containers/configurable-form/configurable-form.component';
import { OnFieldChanged } from '@ordersnproducts/modules/shared/modules/configurable-form/models/on-field-changed';
import { filter, take } from 'rxjs/operators';
import { OneClickUpdateOrderAction } from '../../actions/one-click-orders.actions';
import { OneClickLoadOwnFreightPlantsAction } from '../../actions/one-click-ownFreight-plants.actions';
import { State } from '../../reducers';
import { getOneClickSelectedOrder } from '../../selectors/one-click-orders.selector';

@Injectable()
export class OneClickSetQuantityOrder implements OnFieldChanged {
  constructor(private store: Store<State>) {}

  onFieldChanged(value: number, formGroup: UntypedFormGroup, form: ConfigurableFormComponent): void {
    if (value) {
      this.store
        .select(getOneClickSelectedOrder)
        .pipe(
          filter((order) => !!order),
          take(1),
        )
        .subscribe((order) => {
          const orderUpdated: Order = {
            ...order,
            items: order.items.map((item, index) => {
              if (index === form.mapItem['index']) {
                return {
                  ...item,
                  quantity: value,
                };
              } else {
                return item;
              }
            }),
          };
          if (orderUpdated.shippingCondition.shippingConditionCode === SHIPPING_CONDITION_CODE.OWN_FREIGHT) {
            this.store.dispatch(new OneClickLoadOwnFreightPlantsAction(orderUpdated));
          }
          this.store.dispatch(new OneClickUpdateOrderAction(orderUpdated));
        });
    }
  }
}
